/**
 * GoogleReviewsBar — trust badge linking to Bespoke's Google Business reviews.
 * Uses a static 5-star display + review CTA (no API key needed).
 */
import React from 'react';
import { Star, ExternalLink } from 'lucide-react';

const REVIEW_URL = 'https://g.page/r/CaXoN4uuXmN0EBM/review';
const BUSINESS_PROFILE_URL = 'https://g.page/r/CaXoN4uuXmN0EBM';

const GoogleReviewsBar = ({ compact = false }) => {
  return (
    <div
      className={`bg-white border border-[#BCA480]/30 rounded-lg ${compact ? 'p-3' : 'p-4'} flex flex-wrap items-center justify-center gap-3 sm:gap-6`}
      data-testid="google-reviews-bar"
    >
      <div className="flex items-center gap-2">
        <div className="flex">
          {[1, 2, 3, 4, 5].map(i => (
            <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
          ))}
        </div>
        <div className="text-sm">
          <span className="font-bold text-gray-900">5.0</span>
          <span className="text-gray-600"> · Reviewed on Google</span>
        </div>
      </div>
      <div className="flex items-center gap-2 text-sm">
        <a
          href={BUSINESS_PROFILE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#BCA480] hover:underline font-medium"
          data-testid="google-reviews-read"
        >
          Read Reviews
        </a>
        <span className="text-gray-300">|</span>
        <a
          href={REVIEW_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#BCA480] hover:underline font-medium flex items-center gap-1"
          data-testid="google-reviews-write"
        >
          Leave a Review
          <ExternalLink className="w-3 h-3" />
        </a>
      </div>
    </div>
  );
};

export default GoogleReviewsBar;
